import { useEffect, useState } from "react";
import { api, inr, nfmt, fmtDate } from "./utils";
import { Link } from "react-router-dom";

const METRICS = [
  { key: "invoiced", label: "Highest Invoice Value" },
  { key: "invoiced_count", label: "Highest Invoice Count" },
  { key: "payments", label: "Highest Collections" },
  { key: "customers", label: "Largest Customer Base" },
  { key: "outstanding", label: "Highest Outstanding" },
  { key: "reminders", label: "Most Reminder Activity" },
  { key: "activity", label: "Most Recently Active" },
];

export default function AdminRankings() {
  const [metric, setMetric] = useState("invoiced");
  const [top, setTop] = useState(10);
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true); setErr("");
    try {
      const { data } = await api.get(`/admin/rankings?metric=${metric}&top=${top}`);
      setRows(data.top || []);
    } catch (e) { setErr(e?.response?.data?.detail || "Failed"); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [metric, top]);

  const valOf = (r) => {
    if (metric === "invoiced" || metric === "payments" || metric === "outstanding") return inr(r[metric === "invoiced" ? "total_invoiced" : metric === "payments" ? "total_paid" : "total_outstanding"]);
    if (metric === "invoiced_count") return nfmt(r.total_invoices);
    if (metric === "customers") return nfmt(r.total_customers);
    if (metric === "reminders") return nfmt(r.reminders_total);
    if (metric === "activity") return fmtDate(r.last_activity);
    return "—";
  };

  return (
    <div className="space-y-4" data-testid="admin-rankings">
      <div className="nb-card p-3 flex flex-wrap items-center gap-2">
        <select data-testid="rank-metric" value={metric} onChange={(e) => setMetric(e.target.value)} className="nb-input text-sm px-2 py-2">
          {METRICS.map((m) => <option key={m.key} value={m.key}>{m.label}</option>)}
        </select>
        <select data-testid="rank-top" value={top} onChange={(e) => setTop(Number(e.target.value))} className="nb-input text-sm px-2 py-2">
          {[5, 10, 25, 50].map((n) => <option key={n} value={n}>Top {n}</option>)}
        </select>
      </div>

      {err && <div className="nb-card p-3 bg-[#FF6B6B] text-white text-sm font-bold">{err}</div>}

      <div className="nb-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-[#F3F0E9] text-left">
            <tr>
              <th className="p-3 w-10 font-bold">#</th>
              <th className="p-3 font-bold">Business</th>
              <th className="p-3 font-bold text-right">Value</th>
              <th className="p-3"></th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={4} className="p-6 text-center text-sm">Loading…</td></tr>}
            {!loading && rows.length === 0 && <tr><td colSpan={4} className="p-6 text-center text-sm text-[#4A4A4A]">No data available</td></tr>}
            {rows.map((r, i) => (
              <tr key={r.user_id} className="border-t border-black/10" data-testid={`rank-row-${i + 1}`}>
                <td className="p-3 font-heading font-black">{i + 1}</td>
                <td className="p-3">
                  <div className="font-bold">{r.business_name || r.name || "—"}</div>
                  <div className="text-[11px] text-[#4A4A4A]">{r.email}</div>
                </td>
                <td className="p-3 text-right font-bold">{valOf(r)}</td>
                <td className="p-3 text-right">
                  <Link to={`/admin/businesses/${r.user_id}`} data-testid={`rank-open-${r.user_id}`} className="nb-btn bg-white text-xs px-2 py-1">Open</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
